<template>
	<div class="container-fluid bg-white">
		<toolbar v-if="!contactSlug">
			<h2>
				<i class="fa fa-gavel"></i>
				Service Contracts
			</h2>

			<projects-toolbar-controls
				:is-services="true"
				:mobile-breakpoint="900"
				:action-items="[
					//{text: 'Search',icon:'fa-search'},
					{link: '/service-contract/new/details',text: 'New Contract', icon:'fa-plus'},
					//{link: '/service/new-quote/details',text: 'New Quote', icon:'fa-plus'},
				]">
			</projects-toolbar-controls>

		</toolbar>

		<contact-toolbar v-else></contact-toolbar>

		<collapsible-panel :always-open="!contactSlug" :external-toggle="!contactSlug" panel-size="sm">
			<template slot="panel">
				<panel-menu :menu-items="tabs"
					:active-item="activeTab"
					v-on:itemClick="setActiveTab">
				</panel-menu>
			</template>
			<template slot="main">
				
				<table-list v-if="activeTab == 'Contracts List'"
					record-name="Contract"
					:fields="mutatedFields"
					:records="mutatedContracts"
					:clickable-row="true"
					has-edit="/service-contract/{?}/details"
					:hide-record-count="true"
					:loading="loading"
					:sortable="true"
					id-field="slug">

					<div class="d-flex flex-row justify-content-between">
						<h2>
							Contracts
							<template v-if="contactSlug && $store.contact && 'name' in $store.contact">
								<br>
								<small class="text-muted">{{$store.contact.name}}</small>
							</template>
						</h2>

						<div>
							<button type="button" class="btn btn-success" v-on:click="newContract">
								<i class="fa fa-plus"></i>
								New Contract
							</button>
						</div>
					</div>

					<div class="d-flex flex-row">

						<div v-if="filters" class="mr-2">
							<button class="btn btn-light" v-on:click="clearFilters">
								Show All
							</button>
						</div>

						<field label="Include Expired Contracts"
							col-class="col-auto"
							:params="{type:'boolean'}"
							v-model="includeExpired"
							v-on:change="expiryToggled">
						</field>
					</div>

				</table-list>

				<table-list v-else-if="activeTab == 'Products'"
					record-name="Product"
					:fields="[
						{label: 'Product Title',key:'title'},
						{label: 'Price',key:'price'},
					]"
					:records="products"
					:has-delete="true"
					delete-endpoint="ServiceProduct/delete"
					id-slug="slug"
					:has-edit="true"
					id-field="slug"
					:loading="loading"
					:hide-record-count="true"
					:sortable="true"
					v-on:modelChange="fetchProducts(true)"
					v-on:edit="editProduct">

					<div class="d-flex flex-row justify-content-between">
						<h2>Products</h2>

						<div>
							<button type="button" class="btn btn-success" v-on:click="newProduct">
								<i class="fa fa-plus"></i>
								New Product
							</button>
						</div>
					</div>

				</table-list>

				<div v-else-if="activeTab == 'Reports'" class="text-center">
					<i class="fa fa-chart-pie fa-4x"></i>
					<h2>Contract Reports coming soon!</h2>
				</div>

			</template>
		</collapsible-panel>

		<modal-dialog :modal-visible="editProductDialog.visible"
			:title="editProductDialog.title"
			confirm-button-text="Save"
			:working="editProductDialog.working"
			v-on:closeModal="editProductDialog.visible = false"
			v-on:confirm="saveProduct">

			<field label="Product Title"
				col-class="col-md-4"
				v-model="editProductDialog.payload.title"
				:invalid="$store.errorList.title">
			</field>

			<field label="Price"
				col-class="col-md-4"
				v-model="editProductDialog.payload.price"
				:params="{type:'number',min:0,step:0.01}"
				:invalid="$store.errorList.price">
				<div class="text-muted">For recurring subscription products set the annual price</div>
			</field>

			<field label="Description"
				col-class="stacked"
				v-model="editProductDialog.payload.description"
				:params="{type:'richtext'}">
			</field>

		</modal-dialog>

	</div>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"

import Toolbar from "@/layout_fragments/Toolbar"
import ProjectsToolbarControls from "./ProjectsToolbarControls"
import ContactToolbar from "@/pages/contact/ContactToolbar"

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

import ContactMixins from "@/mixins/ContactMixins"

export default {
	name: "ServiceContracts",
	components: {
		Toolbar,
		ProjectsToolbarControls,
		ContactToolbar,
		TableList,
		CollapsiblePanel,
		PanelMenu,
		ModalDialog,
		Field
	},
	mixins:[ContactMixins],
	data() {
		return {
			contactSlug: null,

			contracts: [],
			products: [],
			includeExpired: false,
			loading: false,
			filters: null,
			editProductDialog: {
				visible: false,
				title: "Add New Product",
				working: false,
				payload: {
					title: "",
					description: "",
					price: ""
				}
			},
			fields: [
				{label: "Customer",key: "customerName"},
				{label: "Internal Ref. #",key: "contract_num",align:'center'},
				{label: "Cust. Ref. #",key: "customer_reference_num",align:'center'},
				{label: "Description",key: "contract_description"},
				{label: "Start",key:"startDate",sortBy:"date"},
				{label: "End",key:"endDate",sortBy:"date"},
				{label: "Time Left",key:"timeLeft"},
			],
			activeTab: "Contracts List",
			tabs: [
				{text: "Contracts List",icon: "fa-gavel"},
				{text: "Products",icon:"fa-tags"},
				{text: "Reports",icon: "fa-chart-pie"}
			]
		}
	},
	computed: {
		mutatedFields() {
			if (this.contactSlug)
				return this.fields.slice(1)
			return this.fields
		},
		mutatedContracts() {
			let vm = this

			return this.contracts.map(contract => {
				contract.customerName = ""
				if (contract.Customer)
					contract.customerName = contract.Customer.name

				contract.startDate = ""
				if (contract.start_date)
					contract.startDate = vm.formatDate(contract.start_date)

				contract.endDate = ""
				if (contract.end_date)
					contract.endDate = vm.formatDate(contract.end_date)

				if (vm.moment(contract.end_date).isBefore(vm.moment()))
					contract.rowClasses = "table-secondary"

				let daysLeft = vm.moment(contract.end_date).diff(vm.moment(),"days")
				let timeLeft
				if (daysLeft > 720)
					timeLeft = vm.moment(contract.end_date).diff(vm.moment(),"years")+" years left"
				else if (daysLeft > 90)
					timeLeft = vm.moment(contract.end_date).diff(vm.moment(),'months')+" months left"
				else
					timeLeft = daysLeft+" days left"

				if (daysLeft < 30)
					contract.timeLeft = "<span class='text-danger'>"+timeLeft+"</span>"
				else
					contract.timeLeft = timeLeft

				return contract
			})
		}
	},
	methods: {
		newContract() {
			if (this.contactSlug && this.$store.contact && 'id' in this.$store.contact && this.$store.contact.id)
				this.$router.push({ path: "/service-contract/new/details", query: { customer_id: this.$store.contact.id } })
			else
				this.$router.push("/service-contract/new/details")
		},
		setActiveTab(item,index) {
			this.activeTab = item.text

			this.fetchData()

			window.history.pushState({},"","/service-contracts/"+item.text.slugify())
		},
		newProduct() {
			this.editProductDialog.visible = true
			this.editProductDialog.payload = {
				title: "",
				description: "",
				price: ""
			}
			this.editProductDialog.title = "Add New Product"
		},
		editProduct(record) {
			this.editProductDialog.visible = true
			this.editProductDialog.payload = this.cloneObj(record)
			this.editProductDialog.title = "Edit Product"
		},
		saveProduct() {
			let vm = this

			this.editProductDialog.working = true

			this.postData("ServiceProduct/save",this.editProductDialog.payload,true).then(response => {
				this.editProductDialog.working = false

				if (response.success) {
					this.alertSaved("Product saved")
					this.editProductDialog.visible = false
					this.fetchProducts()
				}
			})
		},
		expiryToggled() {
			let vm = this
			this.$nextTick(() => {
				vm.fetchContracts()
			})
		},
		clearFilters() {
			this.filters = null
			window.history.pushState({},{},"/service-contracts")
			this.fetchContracts()
		},
		fetchData() {
			if (this.activeTab == "Products")
				this.fetchProducts(true)
			else if (this.activeTab == "Contracts List")
				this.fetchContracts()
		},
		fetchContracts() {
			let vm = this

			let params = {
				include: ['Contact'],
				filters: []
			}

			if (!this.includeExpired)
				params.filters.push(['end_date >',this.moment().format("YYYY-MM-DD")])

			if (this.filters) {
				Object.keys(this.filters).forEach(filterKey => {
					params.filters.push([filterKey,this.filters[filterKey]])
				})
			}

			if (this.contactSlug && this.$store.contact && 'id' in this.$store.contact) {
				params.filters.push(['customer_id', this.$store.contact.id])
			}

			let promises = [
				this.getJSON("ServiceContract/get",params)
			]

			this.spinner(true)
			this.loading = true

			Promise.all(promises).then(responses => {
				vm.contracts = responses[0].data

				vm.spinner(false)
				vm.loading = false
			})

		},
		fetchProducts(spinner) {
			let vm = this

			if (spinner) {
				this.spinner(true)
				this.loading = true
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("ServiceProduct/get").then(response => {
					if (response.success)
						vm.products = response.data

					if (spinner) {
						vm.loading = false
						vm.spinner(false)
					}
					
					resolve()
				})

			})
		}
	},
	created() {
		let vm = this

		if ("query" in this.$route) {
			this.filters = this.cloneObj(this.$route.query)
		}

		if ("id" in this.$route.params)
			this.contactSlug = this.$route.params.id

		if (this.activeTab == "Contracts List") {

			if (this.contactSlug && (!("id" in this.$store.contact) || this.$store.contact.slug != this.$route.params.id)) {
				this.fetchContact(this.$route.params.id, [{model: "ContactFile", fields: []}]).then(() => {
					vm.fetchContracts()
				})
			} else {
				this.fetchContracts()
			}
		}


		if ("tab" in this.$route.params) {
			//set active tab
			let activeTab = this.tabs.find(tab => this.$route.params.tab.slugify() == tab.text.slugify())
			this.activeTab = activeTab.text

			if (this.activeTab == "Products")
				this.fetchProducts(true)
		}
	}
}
</script>